import consts from 'consts'

export default {
  track: function (err) {
    var xhr = new XMLHttpRequest()
    xhr.open(
    'POST',
    '//track.piaoniu.com/report/error/app',
    true)

    xhr.setRequestHeader('ContentType', 'application/json')

    var dict = {
      errorDescription: err.stack,
      env: consts.isProduct ? 'production' : 'beta',
      url: location.href
    }

    var param = JSON.stringify({
      clientType: consts.clientType,
      type: err.message,
      data: dict
    })
    xhr.send(param)
  }
}



// WEBPACK FOOTER //
// ./src/mods/errortrack.js